import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
import { InventoryKindRefusal as n } from "@maat/api-booking/types";
//#region src/enums/useTrInventoryKindRefusal.ts
var r = {
	[n.Modification]: "checkout.inventoryKind.modification",
	[n.UnitChange]: "checkout.inventoryKind.unitChange",
	[n.Invitation]: "checkout.inventoryKind.invitation",
	[n.GuestDocuments]: "checkout.inventoryKind.guestDocuments",
	[n.Checkout]: "checkout.inventoryKind.checkout",
	[n.StayConfirmation]: "checkout.inventoryKind.stayConfirmation"
}, i = (e) => typeof e == "string" && e in r, a = () => {
	let { t: n } = t("booking");
	return e((e) => {
		let t = e?.response?.data?.code;
		return i(t) ? n(r[t]) : void 0;
	}, [n]);
}, o = () => {
	let { t: n } = t("booking");
	return e((e) => i(e) ? n(r[e]) : void 0, [n]);
};
//#endregion
export { a as useTrInventoryKindRefusal, o as useTrInventoryKindRefusalCode };
